/**
 * React context wrapper around `useChatSocket` so deeply nested components
 * can subscribe to socket status without prop drilling. The Provider is
 * intentionally separate from the hook (the latter manages lifecycle, the
 * former exposes the result).
 */
import { createContext, useContext } from "react";
import type { ChatSocketState } from "./useChatSocket";

export const ChatSocketContext = createContext<ChatSocketState | null>(null);

export function useChatSocketContext(): ChatSocketState {
  const ctx = useContext(ChatSocketContext);
  if (!ctx) {
    throw new Error(
      "useChatSocketContext must be used inside <ChatSocketContext.Provider>",
    );
  }
  return ctx;
}
